import { Validators } from '@angular/forms';
import { CustomValidators } from '../../handlers/custom-validators';
import { ServiceInput } from '../../models/service-input.model';
import { INPUT_TYPE } from './input-type.enum';
import { SERVICE_INPUT_ID } from './service-input-id.enum';
import { SERVICE_INPUT_KEYS } from './service-input-keys.enum';

export class ServiceInputFormConfig {
    public static FORM_CONTROL = 'FormControl';

    public static INPUT_INVALID_CHARS = {
        NUMBER_INPUT: ['-', '+', 'e', 'E', '.']
    };

    public static SERVICE_FIELDS_MAX_MIN_LENGTH = {
        contactNumber: { min: 1 },
        simNumber: { min: 1 },
        rechargeNumber: { min: 11, max: 11 },
        deviceNumber: { min: 1 },
        accountNumber: { min: 10, max: 10 },
        slideNumber: { min: 1 },

    };

    public static ALPHANUMERIC_VALIDATORS = [
        CustomValidators.checkWhiteSpaces,
        CustomValidators.specialCharWithoutNumbersValidator,
        CustomValidators.checkWhiteSpaceBetweenString,
        CustomValidators.checkForEnglishAndArabicLetters,
        CustomValidators.checkForBothNumbersAndSpecialChars,
        CustomValidators.checkForBothLettersAndSpecialChars
    ];
    public static PLATEINFOSERVICE_VALIDATORS = [
    
       CustomValidators.onlyLettersAndNumbers
    ];
    public static PLATEINFO_VALIDATORS = [
        CustomValidators.checkForNumbersAndCharacters
    ];

    public static CONTACT_NUMBER_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.CONTACT_NUMBER,
        controlName: SERVICE_INPUT_KEYS.CONTACT_NUMBER + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.NUMBER,
        validators: [Validators.minLength(ServiceInputFormConfig.SERVICE_FIELDS_MAX_MIN_LENGTH.contactNumber.min)],
        errorMessage: 'contactNumberErrorMsg',
        labelName: 'contactNumber'
    };

    public static SIM_NUMBER_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.SIM_NUMBER,
        controlName: SERVICE_INPUT_KEYS.SIM_NUMBER + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.NUMBER,
        validators: [Validators.minLength(ServiceInputFormConfig.SERVICE_FIELDS_MAX_MIN_LENGTH.simNumber.min)],
        errorMessage: 'simNumberErrorMsg',
        labelName: 'simNumber'
    };

    public static IDENTIFICATION_NUMBER_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.IDENTIFICATION_NUMBER,
        controlName: SERVICE_INPUT_KEYS.IDENTIFICATION_NUMBER + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.TEXT,
        validators:  [CustomValidators.checkForNumbersAndHyphen],
        errorMessage: 'identificationNumberErrorMsg',
        labelName: 'identificationNumber'
    };

    public static RECHARGE_NUMBER_FORM_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.RECHARGE_NUMBER,
        controlName: SERVICE_INPUT_KEYS.RECHARGE_NUMBER + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.NUMBER,
        validators: [
            Validators.minLength(ServiceInputFormConfig.SERVICE_FIELDS_MAX_MIN_LENGTH.rechargeNumber.min),
            Validators.maxLength(ServiceInputFormConfig.SERVICE_FIELDS_MAX_MIN_LENGTH.rechargeNumber.max)
        ],
        errorMessage: 'rechargeNumberErrorMsg',
        labelName: 'rechargeNumber'
    };

    public static DEVICE_NUMBER_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.DEVICE_NUMBER,
        controlName: SERVICE_INPUT_KEYS.DEVICE_NUMBER + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.NUMBER,
        validators: [Validators.minLength(ServiceInputFormConfig.SERVICE_FIELDS_MAX_MIN_LENGTH.deviceNumber.min)],
        errorMessage: 'deviceNumberErrorMsg',
        labelName: 'deviceNumber'
    };

    public static START_DATE_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.START_DATE,
        controlName: SERVICE_INPUT_KEYS.START_DATE + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.DATE_RANGE,
        validators: [Validators.required],
        errorMessage: '',
        labelName: 'startDate'
    };

    public static END_DATE_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.END_DATE,
        controlName: SERVICE_INPUT_KEYS.END_DATE + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.DATE_RANGE,
        validators: [Validators.required],
        errorMessage: 'pleaseSelectAnEndDate',
        labelName: 'endDate'
    };

    public static START_TIME_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.START_TIME,
        controlName: SERVICE_INPUT_KEYS.START_TIME + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.TIME_RANGE,
        validators: [Validators.required],
        errorMessage: '',
        labelName: 'startTime'
    };

    public static END_TIME_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.END_TIME,
        controlName: SERVICE_INPUT_KEYS.END_TIME + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.TIME_RANGE,
        validators: [Validators.required],
        errorMessage: 'endTimeBeforeStartTimeErrorMsg',
        labelName: 'endTime'
    };

    public static ACCOUNT_NUMBER_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.ACCOUNT_NUMBER,
        controlName: SERVICE_INPUT_KEYS.ACCOUNT_NUMBER + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.NUMBER,
        validators: [
            Validators.minLength(ServiceInputFormConfig.SERVICE_FIELDS_MAX_MIN_LENGTH.accountNumber.min),
            Validators.maxLength(ServiceInputFormConfig.SERVICE_FIELDS_MAX_MIN_LENGTH.accountNumber.max)
        ],
        errorMessage: 'accountNumberErrorMsg',
        labelName: 'accountNumber'
    };

    public static CAB_NUMBER_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.CAB_NUMBER,
        controlName: SERVICE_INPUT_KEYS.CAB_NUMBER + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.TEXT,
        validators: [CustomValidators.checkWhiteSpaces, CustomValidators.specialCharWithoutNumbersValidator],
        errorMessage: 'cabNumberErrorMsg',
        labelName: 'cabNumber'
    };

    public static CIRCUIT_NUMBER_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.CIRCUIT_NUMBER,
        controlName: SERVICE_INPUT_KEYS.CIRCUIT_NUMBER + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.TEXT,
        validators: [CustomValidators.checkWhiteSpaces, CustomValidators.specialCharWithoutNumbersValidator],
        errorMessage: 'circuitNumberErrorMsg',
        labelName: 'circuitNumber'
    };

    public static MODEM_NUMBER_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.MODEM_NUMBER,
        controlName: SERVICE_INPUT_KEYS.MODEM_NUMBER + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.TEXT,
        validators: ServiceInputFormConfig.ALPHANUMERIC_VALIDATORS,
        errorMessage: 'modemNumberErrorMsg',
        labelName: 'modemNumber'
    };

    public static IP_ADDRESS_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.IP_ADDRESS,
        controlName: SERVICE_INPUT_KEYS.IP_ADDRESS + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.TEXT,
        validators: [CustomValidators.checkWhiteSpaces, CustomValidators.ipAddressValidator],
        errorMessage: 'ipAddressNumberErrorMsg',
        labelName: 'ipAddress'
    };

    public static TOWER_NUMBER_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.TOWER_NUMBER,
        controlName: SERVICE_INPUT_KEYS.TOWER_NUMBER + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.TEXT,
        validators: [CustomValidators.checkWhiteSpaces, CustomValidators.specialCharWithoutNumbersValidator, CustomValidators.checkWhiteSpaceBetweenString],
        errorMessage: 'towerNumberErrorMsg',
        labelName: 'towerNumber'
    };

    public static COORDINATES_INPUT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.COORDINATES,
        controlName: SERVICE_INPUT_KEYS.COORDINATES + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.TEXT,
        validators: [CustomValidators.validLatitudeAndLongitude],
        errorMessage: 'coordinatesErrorMsg',
        labelName: 'coordinates'
    };
    public static PLAT_INFO: ServiceInput = {
        id: SERVICE_INPUT_ID.PLAT_INFO,
        controlName: SERVICE_INPUT_KEYS.PLAT_INFO + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.TEXT,
        validators: ServiceInputFormConfig.PLATEINFOSERVICE_VALIDATORS,
        errorMessage: 'plateInfoErrorMsg',
        labelName: 'plateInfo'
    };
    public static SLIDE_NUMBER: ServiceInput = {
        id: SERVICE_INPUT_ID.SLIDE_NUMBER,
        controlName: SERVICE_INPUT_KEYS.SLIDE_NUMBER + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.NUMBER,
        validators: [Validators.minLength(ServiceInputFormConfig.SERVICE_FIELDS_MAX_MIN_LENGTH.slideNumber.min)],
        errorMessage: 'slideNumberErrorMsg',
        labelName: 'slideNumber'
    };
    public static CUSTOMER_NAME: ServiceInput = {
        id: SERVICE_INPUT_ID.CUSTOMER_NAME,
        controlName: SERVICE_INPUT_KEYS.CUSTOMER_NAME + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.TEXT,
        validators:  [CustomValidators.checkForOnlyEnglishAndArabicLetters],
        errorMessage: 'customerNameErrorMsg',
        labelName: 'customerName'
    };
    public static CUSTOMER_ID: ServiceInput = {
        id: SERVICE_INPUT_ID.CUSTOMER_ID,
        controlName: SERVICE_INPUT_KEYS.CUSTOMER_ID + ServiceInputFormConfig.FORM_CONTROL,
        inputType: INPUT_TYPE.TEXT,
        validators: ServiceInputFormConfig.ALPHANUMERIC_VALIDATORS,
        errorMessage: 'customerIdErrorMsg',
        labelName: 'customerId'
    };
    public static GET_INPUT_FORM_DETAILS: { [key: number]: any } = {
        1: ServiceInputFormConfig.CONTACT_NUMBER_INPUT_INFO,
        2: ServiceInputFormConfig.SIM_NUMBER_INPUT_INFO,
        3: ServiceInputFormConfig.IDENTIFICATION_NUMBER_INPUT_INFO,
        4: ServiceInputFormConfig.RECHARGE_NUMBER_FORM_INFO,
        5: ServiceInputFormConfig.DEVICE_NUMBER_INPUT_INFO,
        6: ServiceInputFormConfig.START_DATE_INPUT_INFO,
        7: ServiceInputFormConfig.END_DATE_INPUT_INFO,
        8: ServiceInputFormConfig.START_TIME_INPUT_INFO,
        9: ServiceInputFormConfig.END_TIME_INPUT_INFO,
        10: ServiceInputFormConfig.ACCOUNT_NUMBER_INPUT_INFO,
        11: ServiceInputFormConfig.TOWER_NUMBER_INPUT_INFO,
        12: ServiceInputFormConfig.COORDINATES_INPUT_INFO,
        13: ServiceInputFormConfig.CAB_NUMBER_INPUT_INFO,
        14: ServiceInputFormConfig.CIRCUIT_NUMBER_INPUT_INFO,
        15: ServiceInputFormConfig.MODEM_NUMBER_INPUT_INFO,
        16: ServiceInputFormConfig.IP_ADDRESS_INPUT_INFO,
        17: ServiceInputFormConfig.PLAT_INFO,
        18: ServiceInputFormConfig.SLIDE_NUMBER,
        19: ServiceInputFormConfig.CUSTOMER_NAME,
        20: ServiceInputFormConfig.CUSTOMER_ID,

        // key represents the service input id found in SERVICE_INPUT_ID
    };
}
